import { isEmpty } from 'lodash'

const resolveEvidences = (answer, quizQuestionTemplate) =>
  isEmpty(answer?.evidences)
    ? quizQuestionTemplate?.evidences || []
    : answer?.evidences

export default resolveEvidences
